import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Utils
import { useIsMobileDimension } from 'utils/hooks/useGetDimensionGroup';

// Components
import { Switch, Options } from 'components';
import RateCost from './components/RateCost';

// Styles
import styles from './styles.pcss';

export const cx = classNames.bind(styles);

export const Description = ({ html }) => {
  if (!html) {
    return null;
  }
  return <div className={cx('description')} dangerouslySetInnerHTML={{ __html: html }} />;
};
Description.propTypes = {
  html: PropTypes.string,
};

const AbstractService = ({
  checked = false,
  disabled = false,
  onChange,
  title,
  children,
  rate,
  priceNote,
  priceDescription,
  currency,
  ratePeriod = 'в месяц',
  rateDate,
  isFuture = false,
  isLoading = false,
  showRateDate,
  isPartnershipTariff,
  productParameters,
}) => {
  const isMobile = useIsMobileDimension();

  return (
    <div className={cx('container')}>
      <Switch
        className={cx('switch')}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        isFuture={isFuture}
        isLoading={isLoading}
      />
      <div className={cx('content')}>
        <div className={cx('title', {
          'title--underlined': isPartnershipTariff,
        })}
        >
          {title}
        </div>
        {isMobile && (
          <div className={cx('rate--mobile')}>
            <RateCost
              rate={rate}
              priceNote={priceNote}
              priceDescription={priceDescription}
              currency={currency}
              ratePeriod={ratePeriod}
              rateDate={rateDate}
              showRateDate={showRateDate}
              isMobile={isMobile}
            />
          </div>
        )}
        {children}
        {!!productParameters?.length && (
          <Options productParameters={productParameters} />
        )}
      </div>
      {!isMobile && (
        <div className={cx('rate')}>
          <RateCost
            rate={rate}
            priceNote={priceNote}
            priceDescription={priceDescription}
            currency={currency}
            ratePeriod={ratePeriod}
            rateDate={rateDate}
            showRateDate={showRateDate}
            isMobile={isMobile}
          />
        </div>
      )}
    </div>
  );
};

AbstractService.propTypes = {
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  rate: PropTypes.number.isRequired,
  ratePeriod: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  rateDate: PropTypes.string,
  priceNote: PropTypes.string,
  priceDescription: PropTypes.string,
  currency: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  isFuture: PropTypes.bool,
  isLoading: PropTypes.bool,
  showRateDate: PropTypes.bool,
  isPartnershipTariff: PropTypes.bool,
  productParameters: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
};

export default AbstractService;
